import React from "react";

const BackgroundContext =
	React.createContext<"light" | "dark" | "media">("light");

export default BackgroundContext;
